import {GET_CHECKOUTS, GET_SHOPIFY_APP_CONNECTION} from '../../../constants';

const checkoutState = {
	count: 0,
	checkouts: null,
	appConnection: null
};

export default function dashboardCheckoutsReducer(state = checkoutState, action) {
	switch (action.type) {
		case GET_CHECKOUTS:
			return Object.assign({}, state, {
				count: action.count,
				checkouts: action.checkouts
			});
		case GET_SHOPIFY_APP_CONNECTION:
			return Object.assign({}, state, {
				appConnection: action.app_connection
			});

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/containers/dashboard-checkouts-page/reducers/index.js